export enum RoutingUrls {
  Main = '/',
  Auth = '/auth',
  Trips = '/trips',
  Passengers = '/passengers',
  Tickets = '/tickets',
  Ticket = '/ticket/:ticketId',
  Booking = '/booking',
  Error = '/error/:code?',
  Settings = '/settings',
}
